export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZarizeni';
export const NAME = 'Zarizeni';
